export const getTargetComponentsResp = [
  {
    operatorCode: "s1gn0l",
    identityId: "7ed4eefc-3162-4973-ab8d-15e2158aaf7b",
    targets: [
      {
        behaviourName: "REDUCED_ENGINE_TAXI_IN",
        targetIncrease: 4,
        baseline: 50,
        modifier: 0,
        performance: 0.0,
      },
      {
        behaviourName: "DELAYED_FLAPS_APPROACH",
        targetIncrease: 10,
        baseline: 50,
        modifier: 0,
        performance: 75.0,
      },
      {
        behaviourName: "EFFICIENT_FLIGHT",
        targetIncrease: 5,
        baseline: 50,
        modifier: 0,
        performance: -25.0,
      },
    ],
  },
  {
    operatorCode: "s2gn0l",
    identityId: "7ed4eefc-3162-4973-ab8d-15e2158aaf7b",
    targets: [
      {
        behaviourName: "REDUCED_ENGINE_TAXI_IN",
        targetIncrease: 4,
        baseline: 50,
        modifier: 4,
        performance: 15.0,
      },
      {
        behaviourName: "DELAYED_FLAPS_APPROACH",
        targetIncrease: 10,
        baseline: 50,
        modifier: 0,
        performance: 75.0,
      },
      {
        behaviourName: "EFFICIENT_FLIGHT",
        targetIncrease: 5,
        baseline: 50,
        modifier: 0,
        performance: -10.0,
      },
    ],
  },
];
